




import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Footer extends Vue {
  get curYear () {
    return new Date().getFullYear()
  }
  get isHome () {
    return this.$route.name === 'home'
  }
}
